import type { ProductStat } from "@itaas/pep-contracts";
import type { PepLocale } from "../../i18n/types";

interface ProductStatsBarProps {
  stats: ProductStat[];
  locale: PepLocale;
}

export function ProductStatsBar({ stats, locale }: ProductStatsBarProps) {
  if (!stats.length) return null;

  return (
    <div className="pep-product-stats row g-3 mt-4">
      {stats.map((stat) => (
        <div className="col-6 col-md-3" key={stat.labelFr}>
          <div className="pep-product-stats__item h-100">
            <div className="pep-product-stats__value">{stat.value}</div>
            <div className="pep-product-stats__label">
              {locale === "en" && stat.labelEn ? stat.labelEn : stat.labelFr}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
